import {Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'chat-message-indicator',
    templateUrl: './botato-chat-message-indicator.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BotatoChatMessageIndicatorComponent {
    @Input()
    public message: string | undefined;
}
